module.exports = __webpack_public_path__ + "img/icon_tags.e07b6372.svg";